import { create } from '@storybook/theming/create'
import dreiLogo from './drei.jpeg'

export default create({
  base: 'light',
  brandImage: dreiLogo,
  appBg: 'white',
})
